import { menu } from '@utils/constants';
import useBreakpoint from '@utils/useBreakpoint';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import AccountMenuGuest from './AccountMenuGuest';
import AccountMenuLogged from './AccountMenuLogged';
import { Provider } from 'react-redux';
import { configureSearchStore } from '@common/state';
let previuslyScrolled = false;
const store = configureSearchStore();
const AccountMenuDesktop = (props) => {
    const [loggedIn, setLoggedIn] = useState(window.loggedin);
    const [wishlistCount, setWishlistCount] = useState(window.wishlistIds.length);
    const [overlayVisible, setOverlayVisible] = useState(false);
    const [animateWishlistIcon, setAnimateWishlistIcon] = useState(false);
    const [forceReload, setForceReload] = useState(false);
    const [profileName, setProfileName] = useState(props.profileName);
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();
    const wrapper = useRef(null);
    const mouseOutTimeout = useRef();
    const mouseInTimeout = useRef();
    useEffect(() => {
        const body = document.querySelector('body');
        let footer = document.querySelector('.footer');
        if (window.innerWidth >= window.mqObj.md && footer) {
            body.style.setProperty('--footer-height', `${footer.clientHeight}px`);
        }
    });
    const handlePreviouslyScrolled = () => {
        var _a;
        let header = document.querySelector('header');
        if (header === null || header === void 0 ? void 0 : header.classList.contains('scrolled')) {
            previuslyScrolled = true;
        }
        else {
            previuslyScrolled = false;
            (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.classList.add('scrolled');
        }
    };
    const firstRender = useRef(true);
    useEffect(() => {
        var _a;
        const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (!firstRender.current) {
            window.sprChat && window.sprChat(overlayVisible ? 'disable' : 'enable');
            if (overlayVisible) {
                handlePreviouslyScrolled();
            }
            else if (!previuslyScrolled) {
                (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.classList.remove('scrolled');
            }
            document.body.classList[overlayVisible ? 'add' : 'remove']('overlay');
            document.body.classList[overlayVisible ? 'add' : 'remove']('no-overflow');
            document.body.style[overlayVisible ? 'setProperty' : 'removeProperty']('--scrollbar-width', scrollBarWidth + 'px');
            if (!overlayVisible && forceReload) {
                window.location.reload();
            }
        }
        firstRender.current = false;
    }, [overlayVisible]);
    useEffect(() => {
        let animateTimeout;
        customEventBus.on('account:update', (data) => {
            let adding = false;
            if (data === null || data === void 0 ? void 0 : data.wishlistIds) {
                if (data.wishlistIds.length > window.wishlistIds.length) {
                    // adding to wishlist
                    adding = true;
                }
                if (breakpoint >= window.mqObj.md) {
                    window.wishlistIds = data.wishlistIds;
                }
                setWishlistCount(data.wishlistIds.length);
            }
            else {
                // window.loggedin updated
                setLoggedIn(window.loggedin);
                if (data.firstName) {
                    setProfileName(data.firstName);
                }
            }
            // >=1 wishlist products
            if (adding && breakpoint >= window.mqObj.md) {
                clearTimeout(animateTimeout);
                setAnimateWishlistIcon(true);
                animateTimeout = setTimeout(() => {
                    setAnimateWishlistIcon(false);
                }, 1500);
            }
        });
        //center menu
        const selectedPage = document.querySelector('.section-menu-new-wrapper .section-menu-new li.selected');
        setTimeout(() => {
            selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }, 1000);
    }, []);
    if (breakpoint < window.mqObj.md) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Provider, { store: store },
        React.createElement("div", { className: classNames('account-wrapper__item', { logged: loggedIn }) },
            React.createElement("div", { className: classNames('account-menu', { 'animate-wishlist-add': animateWishlistIcon }), onMouseEnter: () => {
                    clearTimeout(mouseOutTimeout.current);
                    mouseInTimeout.current = setTimeout(() => {
                        setOverlayVisible(true);
                    }, menu.overlay.timeout);
                }, onMouseLeave: (e) => {
                    let wrapperRects = wrapper.current.getBoundingClientRect();
                    // safety padding, added a standard 20 as fallback
                    let padding = parseInt(window.getComputedStyle(wrapper.current).getPropertyValue('padding-left')) || 20;
                    if (e.clientX < wrapperRects.x + padding ||
                        e.clientX > wrapperRects.right - padding ||
                        e.clientY < wrapperRects.y + padding ||
                        e.clientY > wrapperRects.bottom - padding) {
                        clearTimeout(mouseInTimeout.current);
                        mouseOutTimeout.current = setTimeout(() => {
                            setOverlayVisible(false);
                        }, menu.overlay.timeout);
                    }
                } },
                React.createElement("button", { type: "button", "data-href": loggedIn ? props.myaccountUrl : window.loginUrl, className: classNames('account-cta', { 'with-wishlisticon': wishlistCount > 0 }), "aria-haspopup": "true", id: "accountButton", "data-analytics": `{"event": "menu", "eventCategory": "account menu", "eventAction": ${loggedIn ? '"my moncler"' : '"login"'}}`, onClick: () => {
                        if (document.body.classList.contains('keyboard-mode') || document.documentElement.getAttribute('data-whatintent') == 'touch') {
                            setOverlayVisible(true);
                        }
                        else {
                            window.location.href = loggedIn ? props.myaccountUrl : window.loginUrl;
                        }
                    } },
                    React.createElement("span", { className: loggedIn ? 'icon--account-logged' : 'icon--account' }),
                    React.createElement("span", { className: "account-cta__label" }, t(loggedIn ? 'label.mymoncler' : 'account.login'))),
                React.createElement(FocusTrap, { focusTrapOptions: {
                        onDeactivate: () => setOverlayVisible(false),
                        fallbackFocus: () => wrapper.current,
                        initialFocus: () => wrapper.current,
                        clickOutsideDeactivates: true,
                    }, active: overlayVisible },
                    React.createElement("div", { ref: wrapper, className: classNames(loggedIn ? 'account-dropdown account-dropdown-logged-new' : 'account-dropdown', { visible: overlayVisible }), "aria-modal": overlayVisible, role: "dialog", tabIndex: -1 }, loggedIn ? (React.createElement(AccountMenuLogged, { wishlistUrl: props.wishlistLoggedUrl, myaccountUrl: props.myaccountUrl, wishlistCount: wishlistCount, feedUrl: props.feedUrl, profileUrl: props.profileUrl, detailsUrl: props.detailsUrl, ordersUrl: props.ordersUrl, aftercareUrl: props.aftercareUrl, appointmentsUrl: props.appointmentsUrl, nftWalletUrl: props.nftWalletUrl, logoutUrl: props.logoutUrl, profileName: profileName, closeMenu: () => setOverlayVisible(false) })) : (React.createElement(AccountMenuGuest, { wishlistUrl: props.wishlistGuestUrl, closeMenu: () => setOverlayVisible(false), wishlistCount: wishlistCount, rememberme: props.rememberme, privacypolicy: props.privacypolicy, forgotpasswordform: props.forgotpasswordform, setForceReload: setForceReload, analyticsKey: "menu", reloadPage: true }))))),
            loggedIn && (React.createElement("a", { href: props.logoutUrl, className: "account-logout", "data-analytics": '{"event": "menu", "eventCategory": "account menu", "eventAction": "log out"}' }, t('label.signout'))))));
};
export default AccountMenuDesktop;
